import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'

interface Log {
  message: string | null,
  timeStamp: string | null,
  error: string | null,
}

@Module({ namespaced: true, name: 'SuporteConvitesStore' })
export default class SuporteConvitesStore extends VuexModule {
  public hospitalId: string = ''

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  clearHospitalId() {
    this.hospitalId = ''
  }

  csv: any = {}
  logs: Log[] = []

  @Mutation
  setCsv(value: any) {
    this.csv = value
  }

  @Mutation
  clearCsv() {
    this.csv = {}
  }

  @Mutation
  setLogs(value: Log[]) {
    this.logs = value
  }

  @Mutation
  clearLogs() {
    this.logs = []
  }

  @Action
  async importListaDeSecretariasCsv() {
    try {
      const request = await Apis.Cadastro.CadastroApi.importListaDeSecretariasCsv(this.hospitalId, this.csv)
      if (request.success && request.data.value) this.context.commit('setLogs', request.data.value.cargaConviteMedico as Log[] || [])
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
